<script lang="ts">
  import { orderBy } from '$lib/utils/array';
  import { getContext } from 'svelte';
  import MatchDetailsTeam from './match-details-team.svelte';
  import {
    type MatchStatisticsContext,
    matchStatisticsContext,
  } from './match-details-content.svelte';

  const { teamRankToParticipants, myRank } =
    getContext<MatchStatisticsContext>(matchStatisticsContext);
</script>

<ul>
  {#each [...teamRankToParticipants].sort(orderBy((p) => p[0])) as [rank, players]}
    <li class="team">
      <MatchDetailsTeam isMyTeam={rank == myRank} {rank} {players} />
    </li>
  {/each}
</ul>

<style lang="postcss">
  .team {
    border-bottom: 1px solid var(--border-emphasis);
  }
</style>
